module.exports = __webpack_public_path__ + "static/img/addtwo.8ded644.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/channels/addtwo.png
// module id = HcuN
// module chunks = 1